import React from 'react'

import classes from './HighlightBadge.module.scss'
import { HighlightIcon } from './HighlightIcon'

export const HighlightBadge = () => {
  return (
    <div className={classes.Container}>
      <HighlightIcon />
      <span>Highlights</span>
    </div>
  )
}
